import { TeamRole } from '@/constants';
import { FetchZhankuManagerResponse } from '@/services/user/index.d';
import { CutoutInfo, DayNum, TeamInfoResponse, UserInfo, VipInfo } from '@/services/user/index.d';
import { getUrlParam } from '@/utils';
import { atom } from 'jotai';

/**
 * 标识是否已经请求用户信息接口
 */
export const hasFetchUserInfoAtom = atom<boolean>(false);
/**
 * 用户信息
 */
export const userInfoAtom = atom<UserInfo>();

/**
 * 用户分层标识
 */
export const identificationAtom = atom<string>('');

/**
 * 会员信息
 */
export const vipInfoAtom = atom<VipInfo>();

/**
 * 团队信息
 */
export const teamInfoAtom = atom<TeamInfoResponse['data']>({});

/**
 * 团队角色，管理员/所有者
 */
export const teamRoleAtom = atom<TeamRole>();

/**
 * 批处理数量（PC端批处理订阅）
 */
export const batchSizeAtom = atom<number>(0);

/**
 * 抠图张数信息
 */
export const cutoutInfoAtom = atom<CutoutInfo>();

/**
 * PC端登录跳转地址
 */
export const accountUrlAtom = atom<string>('');

/**
 * 美豆总额
 */
export const meidouTotalAtom = atom<number>(0);

/**
 * 永久美豆
 */
export const meidouForeverTotalAtom = atom<number>(0);
/**
 * 美豆剩余天数列表
 */
export const dayNumListAtom = atom<DayNum[]>([]);

/**
 * 海洛用户标识
 */
export const isFromZhankuAtom = atom<boolean>();

/**
 * 海洛顾问信息
 */
export const ZhankuManagerInfoAtom = atom<FetchZhankuManagerResponse['data']>();

/**
 * 标准会员分佣码
 */
export const rebateCodeAtom = atom<string>('');

/**
 * 高级会员分佣码
 */
export const svipRebateCodeAtom = atom<string>('');

/**
 * 每月赠送美豆数量档次（1：1000美豆/月，2：1800美豆/月，3：3600美豆/月，4：7500美豆/月）
 */
export const giftLevelAtom = atom<number>(+(getUrlParam('gift_level') || '1'));

/**
 * 邀请人uid
 */
export const inviterUidAtom = atom<string>('');
